import Title from "@/components/Title/Title";
import { Link } from "gatsby";
import React from "react";
import S from "./JobList.styled";
import { useJobListData } from "./useJobListData";

export interface Props {
  title: string;
}

const index = ({ title }: Props) => {
  const useData = useJobListData();

  const renderItems = useData.map((item, index) => {
    // make string into swedish date dd mm, yyyy
    const date = new Date(item.ledigaJobbInfo.deadline);
    const dateString = date.toLocaleDateString("sv-SE", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    return (
      <Link key={index} to={item.uri}>
        <S.ItemWrapper>
          <S.ItemTitle>{item.title}</S.ItemTitle>
          <S.ItemText>{item.ledigaJobbInfo.location}</S.ItemText>
          <S.ItemDate>{dateString}</S.ItemDate>
        </S.ItemWrapper>
      </Link>
    );
  });

  const renderMobileItems = useData.map((item, index) => {
    // make string into swedish date dd mm, yyyy
    const date = new Date(item.ledigaJobbInfo.deadline);
    const dateString = date.toLocaleDateString("sv-SE", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    return (
      <Link key={index} to={item.uri}>
        <S.MobileItemWrapper>
          <S.MobileTitle>{item.title}</S.MobileTitle>
          <S.MobileText>Plats: {item.ledigaJobbInfo.location}</S.MobileText>
          <S.MobileText>Sista ansökan: {dateString}</S.MobileText>
        </S.MobileItemWrapper>
      </Link>
    );
  });

  return (
    <div className="main-inner">
      {title && <Title title={title} />}
      <S.Wrapper>
        <S.CategoriesWrapper>
          <S.ItemWrapper>
            <S.FirstCategories>Position</S.FirstCategories>
            <S.SecondCategories>Plats</S.SecondCategories>
            <S.Categories>Sista Ansökan</S.Categories>
          </S.ItemWrapper>
        </S.CategoriesWrapper>
        <S.Container>{renderItems}</S.Container>
      </S.Wrapper>
      <S.MobileWrapper>{renderMobileItems}</S.MobileWrapper>
    </div>
  );
};

export default index;
